import React, { lazy } from 'react';
export function CredibilityBar() {
  return <div className="border-y border-white/5 bg-slate px-5 py-[30px]" data-id="element-115">
      <div className="mx-auto max-w-[900px] text-center" data-id="element-116">
        <p className="mb-5 font-mono text-[11px] uppercase tracking-[3px] text-coolgray" data-id="element-117">
          // Science backed by research from
        </p>
        <div className="flex flex-wrap items-center justify-center gap-10" data-id="element-118">
          {['Stanford University', 'Harvard Medical', 'Huberman Lab', 'NIH Research', 'Salk Institute'].map(logo => <span key={logo} className="font-mono text-[13px] font-bold uppercase tracking-[2px] text-coolgray/40 transition-colors duration-200 hover:text-coolgray" data-id="element-119">
              {logo}
            </span>)}
        </div>
      </div>
    </div>;
}
export function StatsSection() {
  return <section className="bg-navy px-5 py-[60px]" data-id="element-120">
      <div className="mx-auto grid max-w-[900px] grid-cols-2 gap-5 md:grid-cols-4" data-id="element-121">
        <div className="rounded-xl border border-neon/10 bg-slate px-5 py-[30px] text-center" data-id="element-122">
          <div className="mb-2 font-mono text-[42px] font-black leading-none text-neon" data-id="element-123">
            4,200+
          </div>
          <div className="text-[13px] leading-[1.4] text-coolgray" data-id="element-124">
            Professionals Using The Protocol
          </div>
        </div>
        <div className="rounded-xl border border-neon/10 bg-slate px-5 py-[30px] text-center" data-id="element-125">
          <div className="mb-2 font-mono text-[42px] font-black leading-none text-neon" data-id="element-126">
            4.9★
          </div>
          <div className="text-[13px] leading-[1.4] text-coolgray" data-id="element-127">
            Average Rating (480 Reviews)
          </div>
        </div>
        <div className="rounded-xl border border-neon/10 bg-slate px-5 py-[30px] text-center" data-id="element-128">
          <div className="mb-2 font-mono text-[42px] font-black leading-none text-neon" data-id="element-129">
            48hrs
          </div>
          <div className="text-[13px] leading-[1.4] text-coolgray" data-id="element-130">
            Average Time to First Results
          </div>
        </div>
        <div className="rounded-xl border border-neon/10 bg-slate px-5 py-[30px] text-center" data-id="element-131">
          <div className="mb-2 font-mono text-[42px] font-black leading-none text-neon" data-id="element-132">
            7-Day
          </div>
          <div className="text-[13px] leading-[1.4] text-coolgray" data-id="element-133">
            Risk-Free Money Back Guarantee
          </div>
        </div>
      </div>
    </section>;
}
export function PainSection() {
  return <section className="bg-slate px-5 py-20" data-id="element-134">
      <div className="mx-auto max-w-[900px]" data-id="element-135">
        <p className="mb-4 text-center font-mono text-[11px] uppercase tracking-[3px] text-neon" data-id="element-136">
          // DOES THIS SOUND FAMILIAR?
        </p>
        <h2 className="mb-4 text-center text-[clamp(26px,4vw,42px)] font-black leading-[1.2] text-offwhite" data-id="element-137">
          Your Brain is <span className="text-danger" data-id="element-138">Under Attack</span> Every
          Single Day
        </h2>
        <p className="mx-auto mb-[50px] max-w-[650px] text-center text-[17px] leading-[1.7] text-coolgray" data-id="element-139">
          It's not your fault. Modern life is biologically designed to drain
          your cognitive power before noon.
        </p>

        <div className="mb-[30px] grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-140">
          <div className="flex items-start gap-4 rounded-xl border border-danger/15 bg-card p-6 transition-transform duration-200 hover:-translate-y-0.5" data-id="element-141">
            <div className="shrink-0 text-[28px]" data-id="element-142">☕</div>
            <div data-id="element-143">
              <h3 className="mb-1.5 text-[15px] font-bold text-offwhite" data-id="element-144">
                The Caffeine Trap
              </h3>
              <p className="text-[14px] leading-[1.6] text-coolgray" data-id="element-145">
                You're on your 4th coffee but feel more anxious than focused.
                The crash hits at 2:47 PM like clockwork — every single day.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-xl border border-danger/15 bg-card p-6 transition-transform duration-200 hover:-translate-y-0.5" data-id="element-146">
            <div className="shrink-0 text-[28px]" data-id="element-147">🌫️</div>
            <div data-id="element-148">
              <h3 className="mb-1.5 text-[15px] font-bold text-offwhite" data-id="element-149">
                The 3 PM Brain Fog Wall
              </h3>
              <p className="text-[14px] leading-[1.6] text-coolgray" data-id="element-150">
                You read the same paragraph four times and still can't process
                it. Your brain literally "shuts off" when you need it most.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-xl border border-danger/15 bg-card p-6 transition-transform duration-200 hover:-translate-y-0.5" data-id="element-151">
            <div className="shrink-0 text-[28px]" data-id="element-152">📱</div>
            <div data-id="element-153">
              <h3 className="mb-1.5 text-[15px] font-bold text-offwhite" data-id="element-154">
                The Morning Dopamine Drain
              </h3>
              <p className="text-[14px] leading-[1.6] text-coolgray" data-id="element-155">
                Checking your phone within 60 seconds of waking silently
                destroys your ability to focus for the next 4 hours. You don't
                even notice it.
              </p>
            </div>
          </div>
          <div className="flex items-start gap-4 rounded-xl border border-danger/15 bg-card p-6 transition-transform duration-200 hover:-translate-y-0.5" data-id="element-156">
            <div className="shrink-0 text-[28px]" data-id="element-157">😴</div>
            <div data-id="element-158">
              <h3 className="mb-1.5 text-[15px] font-bold text-offwhite" data-id="element-159">
                The "Tired but Wired" Paradox
              </h3>
              <p className="text-[14px] leading-[1.6] text-coolgray" data-id="element-160">
                Exhausted by 9 PM but your brain won't shut off. You wake up
                after "8 hours of sleep" still feeling like you haven't rested
                at all.
              </p>
            </div>
          </div>
        </div>

        <div className="rounded-xl border border-danger/20 bg-danger/5 p-7 text-center text-[18px] text-offwhite" data-id="element-161">
          You're not lazy. You're not "getting old."{' '}
          <strong className="text-danger" data-id="element-162">
            Your biology is simply miswired for the 2026 workplace.
          </strong>
          <br data-id="element-163" />
          <span className="mt-2 block text-[16px] text-coolgray" data-id="element-164">
            And there is a precise, 15-minute biological fix. Keep reading.
          </span>
        </div>
      </div>
    </section>;
}
export function AuthorSection() {
  return <section className="bg-navy px-5 py-20" data-id="element-165">
      <div className="mx-auto max-w-[900px]" data-id="element-166">
        <p className="mb-4 text-center font-mono text-[11px] uppercase tracking-[3px] text-neon" data-id="element-167">
          // WHO IS BEHIND THIS PROTOCOL
        </p>
        <h2 className="mb-4 text-center text-[clamp(26px,4vw,42px)] font-black leading-[1.2] text-offwhite" data-id="element-168">
          From <span className="text-danger" data-id="element-169">Zombie Professional</span> to{' '}
          <span className="text-neon" data-id="element-170">Unstoppable Brain</span>
        </h2>

        <div className="mt-[50px] grid grid-cols-1 items-start gap-10 rounded-[20px] border border-neon/10 bg-slate p-[50px] md:grid-cols-[200px_1fr]" data-id="element-171">
          <div className="mx-auto flex h-[180px] w-[180px] shrink-0 items-center justify-center rounded-full border-4 border-neon/30 bg-gradient-to-br from-card to-slate text-[70px] shadow-[0_0_40px_rgba(0,255,65,0.15)] md:mx-0" data-id="element-172">
            🧑‍🔬
          </div>
          <div className="text-center md:text-left" data-id="element-173">
            <h3 className="mb-1 text-[24px] font-black text-offwhite" data-id="element-174">
              Dr. James R. Mitchell
            </h3>
            <p className="mb-5 font-mono text-[13px] tracking-[2px] text-neon" data-id="element-175">
              // NEUROBIOLOGY RESEARCHER & PERFORMANCE COACH — AUSTIN, TX
            </p>
            <div className="space-y-4 text-[15px] leading-[1.8] text-coolgray" data-id="element-176">
              <p data-id="element-177">
                In 2021, I was earning $180K a year as a Senior Product Lead at
                a tech firm in Austin — and I was completely broken. My brain
                would shut down every afternoon around 3 PM. I was taking
                Modafinil, Adderall, and 5 different "nootropic stacks" just to
                keep up.
              </p>
              <p data-id="element-178">
                The turning point came when I spent 8 months deep-diving into
                circadian neurobiology research from Stanford, Harvard, and the
                Salk Institute. What I found changed everything:{' '}
                <strong className="text-offwhite" data-id="element-179">
                  I wasn't broken. I was just biologically miswired by my
                  environment.
                </strong>
              </p>
              <p data-id="element-180">
                I stripped everything down to the 20% of biological inputs that
                drive 80% of cognitive performance. No $40,000 machines. No 40
                pills per day. Just the three master switches: Light,
                Temperature, and Timing.
              </p>
              <p data-id="element-181">
                The result? I eliminated my afternoon fog completely within 72
                hours. I've since shared this protocol with over 4,200
                professionals across the United States. This is that protocol.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function RevelationSection() {
  return <section className="bg-slate px-5 py-20" data-id="element-182">
      <div className="mx-auto max-w-[900px]" data-id="element-183">
        <p className="mb-4 text-center font-mono text-[11px] uppercase tracking-[3px] text-neon" data-id="element-184">
          // THE BIOLOGICAL SOLUTION
        </p>
        <h2 className="mb-4 text-center text-[clamp(26px,4vw,42px)] font-black leading-[1.2] text-offwhite" data-id="element-185">
          The 3 Master Switches of the{' '}
          <span className="text-neon" data-id="element-186">Unstoppable Brain</span>
        </h2>
        <p className="mx-auto mb-[50px] max-w-[650px] text-center text-[17px] leading-[1.7] text-coolgray" data-id="element-187">
          Most biohacking is expensive theater. 80% of your cognitive edge comes
          from just 3 zero-cost biological switches.
        </p>

        <div className="my-10 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-188">
          <div className="rounded-xl border border-neon/10 bg-card px-6 py-[30px] text-center transition-all duration-300 hover:-translate-y-1 hover:border-neon/40 hover:shadow-[0_0_30px_rgba(0,255,65,0.1)]" data-id="element-189">
            <div className="mb-4 text-[40px]" data-id="element-190">☀️</div>
            <h3 className="mb-2.5 text-[18px] font-bold text-neon" data-id="element-191">
              SWITCH 1: LIGHT
            </h3>
            <p className="text-[14px] leading-[1.6] text-coolgray" data-id="element-192">
              10 minutes of morning sunlight resets your Suprachiasmatic Nucleus
              (SCN), triggering a 16-hour energy cycle. It costs $0 and takes 10
              minutes. Nothing else compares.
            </p>
          </div>
          <div className="rounded-xl border border-neon/10 bg-card px-6 py-[30px] text-center transition-all duration-300 hover:-translate-y-1 hover:border-neon/40 hover:shadow-[0_0_30px_rgba(0,255,65,0.1)]" data-id="element-193">
            <div className="mb-4 text-[40px]" data-id="element-194">🌡️</div>
            <h3 className="mb-2.5 text-[18px] font-bold text-neon" data-id="element-195">
              SWITCH 2: TEMPERATURE
            </h3>
            <p className="text-[14px] leading-[1.6] text-coolgray" data-id="element-196">
              A 2-minute cold shower finish triggers a 250% surge in Dopamine
              and Norepinephrine that lasts 3+ hours. No supplement can
              replicate this at $0 cost.
            </p>
          </div>
          <div className="rounded-xl border border-neon/10 bg-card px-6 py-[30px] text-center transition-all duration-300 hover:-translate-y-1 hover:border-neon/40 hover:shadow-[0_0_30px_rgba(0,255,65,0.1)]" data-id="element-197">
            <div className="mb-4 text-[40px]" data-id="element-198">⏰</div>
            <h3 className="mb-2.5 text-[18px] font-bold text-neon" data-id="element-199">
              SWITCH 3: TIMING
            </h3>
            <p className="text-[14px] leading-[1.6] text-coolgray" data-id="element-200">
              Delaying caffeine by just 90 minutes after waking eliminates the 3
              PM crash permanently. It's not willpower. It's adenosine
              biochemistry.
            </p>
          </div>
        </div>
      </div>
    </section>;
}